import { Injectable } from '@angular/core';
import { Annonce } from "../models/annonce";
import { Deserialize } from "cerialize";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AnnonceService {

  baseApiUrl: string = environment.api.baseUrl;

  private _annonces: BehaviorSubject<Annonce[]> = new BehaviorSubject(null);
  public readonly annonces: Observable<Annonce[]> = this._annonces.asObservable().pipe(filter(annonces => annonces != null));

  constructor(private http: HttpClient) {
  }

  load(): Observable<Annonce[]> {
    return this.http.get(`${this.baseApiUrl}annonces`).pipe(switchMap(data => {
        this._annonces.next(Deserialize(data, Annonce));
        return this.annonces;
      })
    );
  }

  findById(id: number): Observable<Annonce> {
    if(this._annonces.value == null){
      this.load().toPromise();
    }
    return this.annonces.pipe(map(annonces => annonces.find(annonce => annonce.id == id)));
  }
}
